import { render, staticRenderFns } from "./ev5-imgs-swiper.vue?vue&type=template&id=7bff8f0e&scoped=true&"
import script from "./ev5-imgs-swiper.vue?vue&type=script&lang=js&"
export * from "./ev5-imgs-swiper.vue?vue&type=script&lang=js&"
import style0 from "./ev5-imgs-swiper.vue?vue&type=style&index=0&id=7bff8f0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bff8f0e",
  null
  
)

export default component.exports